var path = '/components/components/selectize/component.tpl.html';
var html = "<div class=\"al-select\">\n    <select ng-model=\"ngModel\"></select>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/components/selectize/component.tpl.html
// module id = 1975
// module chunks = 1